/*eslint-enable*/
( function () {
	'use strict';

	const capesMenu = document.querySelector( '.capes-menu' );

	if( capesMenu ) {
		document.addEventListener( 'scroll', function() {
			const siteFooter = document.querySelector( '.site-footer' );
			const firstBlock = document.querySelector( '.main-content > section:first-of-type' );
			const footerRect = siteFooter.getBoundingClientRect();
			const firstBlockRect = firstBlock.getBoundingClientRect();
			const viewportHeight = window.innerHeight;

			if ( 99 < window.scrollY ) {
				capesMenu.classList.remove( 'capes-menu--hide' );
			} else if ( ( firstBlockRect.top <= viewportHeight - 95 ) || ( footerRect.top <= viewportHeight + 50 ) ) {
				capesMenu.classList.add( 'capes-menu--hide' );
			} else {
				capesMenu.classList.remove( 'capes-menu--hide' );
			}
		} );
	}

}() );
/*eslint-disable*/

